import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/forgot-password/page";

export const Route = createFileRoute("/auth/forgot-password/")({
  component: Page,
});
